import React from "react";
import PropTypes from "prop-types";
import { Box, Button, makeStyles } from "@material-ui/core";

import { useDispatch } from "react-redux";
import routePaths from "@/utils/route-paths";
import * as navigationActions from "@/store/actions/navigationActions";

import * as Image404 from "@/assets/404.png";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		marginTop: theme.spacing(12),
		flexDirection: "column",
	},
	buttonContainer: {
		marginTop: theme.spacing(3),
	},
	image: {
		width: "100%",
		height: "100%",
	},
}));

const NotFoundPage = ({ button }) => {
	const classes = useStyles();

	const dispatch = useDispatch();
	const goToRoute = () => {
		dispatch(navigationActions.goToRoute(button.goto));
	};
	return (
		<Box className={classes.root}>
			<Box>
				<img src={Image404} className={classes.image} />
			</Box>
			<Box className={classes.buttonContainer}>
				<Button color="primary" onClick={goToRoute} label={button.label} />
			</Box>
		</Box>
	);
};

export default NotFoundPage;

NotFoundPage.propTypes = {
	button: PropTypes.object,
};

NotFoundPage.defaultProps = {
	button: {
		label: "Go To Home Page",
		goto: routePaths.DASHBOARD,
	},
};
